var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-button",attrs:{"href":"javascript:;"}},[_c('div',{staticClass:"button_content",class:[
      {
        disable: _vm.status === 'disable',
        loading: _vm.status === 'loading',
        gray: _vm.status === 'gray'
      },
      _vm.type
    ],on:{"click":_vm.clickButton}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.status !== 'loading'),expression:"status !== 'loading'"}],staticClass:"login_text"},[_vm._v(_vm._s(_vm.text))]),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'loading'),expression:"status === 'loading'"}],attrs:{"src":require("@/assets/icons-file/gif/loading.gif")}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }